import { useMatches } from 'react-router';

import { Separator } from '@/components/ui/separator';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { GlobalBanner } from '@/global/announcement/components/global-banner';
import { UserNavigation } from '@/global/navigation/components/UserNavigation';
import MainSearch from '@/global/search/components/MainSearch';
import { SidebarTrigger } from '@/global/sidebar/components/SidbarTrigger';
import { AppSidebar } from '@/global/sidebar/components/Sidebar';

import { Progress } from './progress';

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  const matches = useMatches() as Array<{ handle: { title: string } }>;

  const currentRoute = matches.reverse().find((match) => match.handle?.title);
  const pageTitle = currentRoute?.handle?.title || 'SCL';
  return (
    <div className="flex h-dvh overflow-hidden">
      <div className="flex w-0 flex-1 flex-col overflow-hidden">
        <SidebarProvider>
          <AppSidebar />
          <SidebarInset>
            <GlobalBanner />
            <header className="z-10 flex h-16 shrink-0 items-center gap-2 border-b border-border/40 bg-background/95 shadow backdrop-blur transition-[width,height] ease-linear supports-[backdrop-filter]:bg-background/60">
              <Progress />
              <div className="flex flex-1 items-center px-4 md:pr-6 lg:pr-8">
                <div className="flex items-center gap-2 px-2">
                  <SidebarTrigger />
                  <Separator
                    orientation="vertical"
                    className="mr-2 hidden h-4 sm:block"
                  />
                  <h1 className="hidden whitespace-nowrap text-lg sm:block">
                    {pageTitle}
                  </h1>
                </div>
                <div className="ml-auto w-full px-4 sm:w-auto">
                  <MainSearch />
                </div>
                <div className="flex items-center">
                  <UserNavigation />
                </div>
              </div>
            </header>
            <main className="relative flex-1 overflow-y-auto focus:outline-none">
              {children}
            </main>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </div>
  );
}
